<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmBreadcrumb />
    <LmForm ref="lmForm">
      <LmTextInput
        v-model="form.name"
        :v="$v.form.name"
        label="name"
        placeholder="name"
      />
      <LmTextArea
        id="mjml-template"
        v-model="form.template"
        :v="$v.form.template"
        rows="11"
        :maxLength="20000"
        label="MJML Template"
        :placeholder="`
  <mjml>
    <mj-body>
      <mj-section>
        <mj-column>
          <mj-text>
            Hello World!
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>
        `.trim()"
      />
      <LmSelect
        v-model="form.published"
        :v="$v.form.published"
        :options="optionsPublish"
        label="Publicado"
        />
      <LmButton type="button" value="Previsualizar template" @click.native="preview()"/>
      <div class="row">
        <div class="col-12">
          <LmButton
            type="button"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            @click.native="cancelBtn"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
          />
          <LmButton
            type="button"
            :value="$t('Save')"
            :isProcessing="isFormProcessing"
            @click.native="submit()"
            buttonClass="btn-primary"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            :disabled="isDisabledByUserPrivileges()"
          />
          <p
            v-if="isDisabledByUserPrivileges()"
            class="font-italic text-danger"
          >
            Lo sentimos, no tiene permisos para guardar los cambios.
          </p>
        </div>
      </div>
    </LmForm>
    <LmTemplatePreviewModal ref="lmTemplatePreviewModal"/>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmTemplatePreviewModal from '@/components/modals/LmTemplatePreviewModal'

import { checkSoftPermissions, getCurrentUserRole } from '@/helpers/LmUserPermissions'

import { required } from 'vuelidate/lib/validators'
import axios from 'axios'

import lmToasts from '@/mixins/lmToasts.js'
export default {
  mixins: [lmToasts],
  data () {
    return {
      optionsPublish: {
        content: [{ value: true, text: 'Si' }, { value: false, text: 'No' }]
      },
      form: {
        name: '',
        template: `<mjml>
    <mj-body>
      <mj-section>
        <mj-column>
          <mj-text>
            Hello World!
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>`,
        type: 'email',
        published: false
      },
      isFormProcessing: false,
      initialForm: {},
      viewPermissions: {
        allowAccess: process?.env?.VUE_APP_FORM_MAILERTEMPLATE_ALLOW_PERMISSIONS?.split(',') || [],
        allowCreateContent: process?.env?.VUE_APP_FORM_MAILERTEMPLATE_CREATE_PERMISSIONS?.split(',') || [],
        allowUpdateContent: process?.env?.VUE_APP_FORM_MAILERTEMPLATE_UPDATE_PERMISSIONS?.split(',') || [],
        allowDeleteContent: process?.env?.VUE_APP_FORM_MAILERTEMPLATE_DELETE_PERMISSIONS?.split(',') || []
      },
      userPrivileges: {},
      userRole: getCurrentUserRole()
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmTextArea,
    LmSelect,
    LmButton,
    LmTemplatePreviewModal
  },
  validations: {
    form: {
      name: {
        required
      },
      published: {
        required
      },
      template: {
        required
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/templates/listado'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    saveEndpoint: {
      type: String,
      default: null
    },
    previewTemplateEndpoint: {
      type: String,
      default: `${process.env.VUE_APP_API_URL}templates/new/`
    }
  },
  methods: {
    isDisabledByUserPrivileges (btnType = 'save') {
      if (this.userRole !== 'Superusuario') {
        // Crear
        if (!this.userPrivileges.allowCreateContent && !this.isOnEditMode) {
          return true
        }
        // Actualizar
        if (!this.userPrivileges.allowUpdateContent && this.isOnEditMode) {
          return true
        }
        // Eliminar
        if (!this.userPrivileges.allowDeleteContent && this.isOnEditMode && btnType === 'delete') {
          return true
        }
      }
      return false
    },
    async setForm () {
      if (this.isOnEditMode) {
        if (this.saveEndpoint) {
          // Condicional creado para mejorar la logica del template sin crear uno nuevo y manteniendo
          // compatibilidad hacia atrás
          this.$refs.lmForm.activeEditMode({
            path: this.saveEndpoint,
            id: this.$route.params.id,
            paramsMode: true
          })
            .catch(error => {
              console.log(error)
              this.$router.replace({ name: '404' })
            })
        } else {
          // Se comporta como se espera en versiones anteriores de emailtemplates
          this.$refs.lmForm.activeEditMode({
            path: 'templates/email/read/',
            id: this.$route.params.id
          })
            .catch(error => {
              console.log(error)
              this.$router.replace({ name: '404' })
            })
        }
      } else {
        this.form = JSON.parse(this.initialForm)
      }
    },
    cancelBtn () {
      if (this.$v.form.$invalid) {
        this.$router.push(this.onSuccessDestinationRoute)
      } else {
        if (confirm(this.$t('cancel_msg'))) {
          this.$router.push(this.onSuccessDestinationRoute)
        }
      }
    },
    async preview () {
      await this.$refs.lmForm.validationForm(this.$v)
      try {
        const previewData = {
          name: this.form.name,
          template: this.form.template.trim(),
          type: this.form.type,
          preview: true,
          published: this.form.published
        }
        const response = await axios.post(
          this.previewTemplateEndpoint,
          previewData
        )
        const template = JSON.parse(response.data.template).html
        this.$refs.lmTemplatePreviewModal.openEmailPreviewModal(template)
      } catch (error) {
        console.log(error)
      }
    },
    async submit () {
      try {
        this.isFormProcessing = true
        await this.$refs.lmForm.validationForm(this.$v)

        if (this.saveEndpoint) {
          // Condicional creado para mejorar la logica del template sin crear uno nuevo y manteniendo
          // compatibilidad hacia atrás
          if (this.isOnEditMode) {
            const dataToSendToTheServer = {
              name: this.form.name,
              template: this.form.template.trim(),
              type: this.form.type,
              published: this.form.published
            }
            await axios.put(
              `${this.saveEndpoint}/${this.$route.params.id}`,
              dataToSendToTheServer
            )
          } else {
            // Se comporta como se espera en versiones anteriores de emailtemplates
            const dataToSendToTheServer = {
              name: this.form.name,
              template: this.form.template.trim(),
              type: this.form.type,
              published: this.form.published
            }
            await axios.post(
              this.saveEndpoint,
              dataToSendToTheServer
            )
          }
        } else {
          const dataToSendToTheServer = {
            name: this.form.name,
            template: this.form.template.trim(),
            type: this.form.type,
            preview: false,
            published: this.form.published,
            isOnEditMode: this.isOnEditMode,
            id: this.form.id
          }
          await axios.post(
            `${process.env.VUE_APP_API_URL}templates/new/`,
            dataToSendToTheServer
          )
        }
        this.$router.push(this.onSuccessDestinationRoute)
      } catch (error) {
        console.log(error)
      } finally {
        this.isFormProcessing = false
      }
    }
  },
  created () {
    // Check user permissions
    this.userPrivileges = checkSoftPermissions(this.viewPermissions)
    if (!this.userPrivileges.allowAccess && this.userRole !== 'Superusuario') {
      this.lmToastDangerMessage('Lo sentimos, no tiene permisos para realizar esta acción.', 'Error al acceder')
      this.$router.push('/')
    }

    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  }
}
</script>
